import * as React from 'react';
import { InversifyContext } from '@workbench-stack/components';
import { getApolloContext } from '@apollo/react-common';
import { ClientTypes as CommonTypes } from '@common-stack/client-react';

let __service_instance__;
export function useService<T>() {
  const { container, modules } = React.useContext(InversifyContext);
  const { client } = React.useContext(getApolloContext());
  if (__service_instance__) {
    return __service_instance__ as T;
  }
  if (!container) {
    throw new Error('Container is null');
  }
  if (!container.isBound(CommonTypes.ApolloClient)) {
    container.bind(CommonTypes.ApolloClient).toDynamicValue(context => client);
  }
  if (!container.isBound(CommonTypes.InMemoryCache)) {
    container
      .bind(CommonTypes.InMemoryCache)
      .toDynamicValue(context => client.cache);
  }

  __service_instance__ = modules.createService({}, {});
  console.log('__service_instance__: ', __service_instance__);
  return __service_instance__ as T;
}
